/**
 * @file
 */

import { CreateTHEADSectionGV } from "@/common/common.js";
import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

/**
 * Initialize Bank Account Maintenance for validation and rename button processing.
 */
export function InitializeOLPPaymentAccountsPage() {
      // ============================================================================================
      //   initialize the validation engine
      // ============================================================================================
      var onSubmit = false;
      customValidationInit(onSubmit);
      aspControlValidationInit();

      // -------------------------------------------------------------------------------------------
      // create the thead section for the gridView since datagrids don't natively have it.
      //    this is mainly for ADA
      // -------------------------------------------------------------------------------------------
      CreateTHEADSectionGV("gvAccounts");

      // -------------------------------------------------------------------------------------------
      // initialize gridview to handle responsive web design
      // -------------------------------------------------------------------------------------------
      $('.responsiveTable').DataTable({
         "responsive": true,
         "scrollX": false,
         "paging": false,
         "searching": false,
         "ordering": false,
         "info": false

      });
      // ============================================================================================
      //   linkbox click events
      // ============================================================================================
      $(".jqRename").click(function (e) {
         var msg2display;
         var lbID = $(this).attr('id');
         var tbID = lbID.replace('btnRename', 'txtGridRename');
         var tbCntl = document.getElementById(tbID);
         var tbText = $(tbCntl).val();
         if (tbText === '')
         {
            msg2display = 'Account Name cannot be nothing. Please enter a name before clicking the RENAME button.';
            alert(msg2display);
            return false;
         }
         msg2display = 'Do you want to change Account Name to:  ' + tbText;
         return confirm(msg2display);
      })
};
